import React from "react";
import AnswerListItem from "../../../test/AnswerListItem";
import CustomCheckbox from "../../../../partial/CustomCheckbox";
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonChecked from "@material-ui/icons/RadioButtonChecked";
import {ListItemIcon, ListItemText} from "@material-ui/core";
import ConvertToLatex from "../../../../helper/ConvertToLatex";
import StyleQuestionDetail from "../../../../partial/styles/StyleQuestionDetail";
import {questionTypes} from "../../../../../config/constants";
import CheckBoxIconBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ReactHtmlParser from 'react-html-parser';
import {testTypes} from './../../../../../config/constants';

const NormalAnswerDetail = (props) => {
    const {testTypeId, answer, index, questionType} = props;
    const classes = StyleQuestionDetail();

    const unCheckIcon = (questionType === questionTypes.MULTIPLE_CHOICE) ?
        <RadioButtonUnchecked className={classes.checkBox}/> : <CheckBoxIconBlank className={classes.checkBox}/>;
    const checkedIcon = (questionType === questionTypes.MULTIPLE_CHOICE) ?
        <RadioButtonChecked className={classes.checkBox}/> : <CheckBoxIcon className={classes.checkBox}/>;

    let className = classes.normalAnswer;
    if (testTypeId !== testTypes.BINH_CHON && testTypeId !== testTypes.KHAO_SAT)
    {
        if (answer.isCorrectAnswer)
            className = classes.correctAnswer;
        else if (answer.isStudentAnswer)
            className = classes.wrongAnswer;
    }

    return (
        <React.Fragment>
            <AnswerListItem
                disableRipple
                button
                key={index}
                selected={answer.isStudentAnswer}
                style={{height: 'auto'}}
            >
                <ListItemIcon style={{minWidth: 10}}>
                    <CustomCheckbox
                        icon={unCheckIcon}
                        checkedIcon={checkedIcon}
                        edge="start"
                        checked={answer.isStudentAnswer}
                        tabIndex={-1}
                        disableRipple
                        disabled={props.disabled}
                    />
                </ListItemIcon>
                {answer.content ?
                    answer.content.search("latex") === -1 ?
                        <ListItemText
                            className={className}>
                            {ReactHtmlParser(answer.content)}
                        </ListItemText> :
                        <div>
                            <ListItemText
                                className={className}>
                                <ConvertToLatex textInput={answer.content}/>
                            </ListItemText>
                        </div> : ""}
            </AnswerListItem>
        </React.Fragment>
    );
};
export default NormalAnswerDetail;